import React from "react";
import "./footer.css";
const Footer = () => {
	return (
		<>
			<footer class=" font-small">
				<div class=" text-center py-3 text-black">CRA-APP</div>
			</footer>
		</>
	);
};

export default Footer;
